export default {
  isOpsZoneShouldBePrefilled: false,
  isNightCardsSupport: true,
  opsZoneMapFill: 'rgba(0, 117, 153, 0.07)',
  opsZoneMapStroke: '#559D37',
  communeMapFill: 'rgba(6, 148, 211, 0.20)',
  communeMapStroke: '#0075A9',
  /** Public info URL for Night Card program (TBD). Used for sign-up, checkout, and settings links. */
  nightCardProgramInfoUrl: 'https://www.nightrider.lu/{locale}/nightcard/',
  isAnimalsFeatureShown: true,
  languages: ['en', 'de', 'fr'],
  defaultLanguage: 'en',
  extendedCookieSupport: true,
};
